<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="isDirectUser ? '다이렉트 메시지' : '스카우트 제의'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="margin-top: 20px; padding: 0 12px; flex: 1; overflow-y: scroll;">
            <div style="font-weight: 500; font-size: 20px; line-height: 24px;">{{ memberInfo.nic_name }}님에게<br>{{ isDirectUser ? '다이렉트 메시지' : '스카우트 제의' }} 보내기</div>
            <div style="display: flex; gap: 8px; align-items: center; margin-top: 20px;">
                <div>
                    <ProfileImage style="width: 60px" :image-path="memberInfo.image_path"></ProfileImage>
                </div>
                <div style="font-size: 14px; font-weight: 700;">{{ memberInfo.nic_name }} <span style="font-weight: 500; color: var(--color-main);">{{ memberInfo.position }}</span></div>
            </div>
            <div v-if="main_type === MAIN_TYPE.SOCCER_LEARN" style="margin-top: 8px;">
                <CommonPost :hideOption="true" :isDetail="true" :isFeed="main_type === MAIN_TYPE.SOCCER_LEARN ? true : false" :soccerHows="soccerhow"></CommonPost>
            </div>
            <div style="margin-top: 20px;">
                <div style="font-size: 14px; font-weight: 700; line-height: 24px;">보낼 메시지</div>
                <textarea :placeholder="placeholder" :ref="'textarea'" v-model="contents" style="border: none; outline: none; resize: none; border-radius: 12px; margin-top: 8px; padding: 12px; line-height: 24px; width: 100%; height: 208px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%);" name="" id=""></textarea>
            </div>
        </div>
        <div style="padding: 0 12px; margin-bottom: 40px; padding-top: 12px;">
            <div @click="controlSendIndividualMessage" style="height: 56px; line-height: 56px; border-radius: 50px; background-color: var(--color-main); text-align: center; font-weight: 700; font-size: 14px;">{{ isDirectUser ? '다이렉트 메시지 보내기' : '스카우트 제의 보내기' }}</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import { MAIN_TYPE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'SendIndividualMessage',
    components: { MercenaryHeader, ProfileImage, CommonPost },
    props: {
        memberInfo: {
            type: Object,
            default: () => { }
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        main_type: {
            type: String,
            defualt: ''
        },
        soccerhow: {
            type: Object,
            default: () => { }
        },
        isDirectUser: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            contents: '',
            MAIN_TYPE: MAIN_TYPE,
            cur_modal_length: -1,
            placeholder: '팀에 영입하고 싶은 이유를 전달할 수 있습니다! 간단한 자기 소개와 함께 입단 테스트 일정을 잡고 팀 입단 시 혜택 등을 소개하세요.\n\n 예시) 안녕하세요 맨시티 감독입니다. 저희 팀에 어울리는 플레이 스타일을 보여주셔서 관심이 있었으며, 입단 테스트 일정을 잡고자 합니다.'
        }
    },
    beforeDestroy() {
        window.visualViewport.removeEventListener('resize', this.detectResize);
    },
    mounted() {
        window.visualViewport.addEventListener("resize", this.detectResize);
    },
    created() {
        this.sendIndividualMessage = this.$Once(this.sendIndividualMessage)
        this.sendDirectMessageForUser = this.$Once(this.sendDirectMessageForUser)
        this.cur_modal_length = this.$GlobalStore.getModalLength();
    },
    methods: {
        detectResize() {
            if (window.visualViewport.offsetTop === 0) {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.unsetLastModalFixedInIOS(this.cur_modal_length - 1);
                }
            } else {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.setLastModalFixedInIOS(window.visualViewport.offsetTop, window.visualViewport.height);
                }
            }
        },
        controlSendIndividualMessage() {
            if (this.contents.length < 5) {
                setTimeout(() => {
                    alert('5자 이상 입력해주세요.')
                    return
                }, 100);
            } else {
                if (this.isDirectUser) {
                    this.sendDirectMessageForUser()
                } else {
                    this.sendIndividualMessage()
                }
            }
        },
        async sendIndividualMessage() {
            const formData = new FormData()
            formData.append('refer_idx', this.soccerhowIdx)
            formData.append('contents', this.contents)

            const res = await this.$Axios.post('/api/direct_message/send', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.showAlert('다이렉트 메시지를 보냈습니다.')
                this.$GlobalStore.closeLastModal()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async sendDirectMessageForUser() {
            const formData = new FormData()
            formData.append('member_idx', this.memberInfo.idx ? this.memberInfo.idx : this.memberInfo.member_idx)
            formData.append('contents', this.contents)

            const res = await this.$Axios.post('/api/direct_message/send/user', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.showAlert('다이렉트 메시지를 보냈습니다.')
                this.$GlobalStore.closeLastModal()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        }
    }
}
</script>

<style scoped>
textarea::placeholder {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #bbbbbb;
}
</style>